import classNames from 'classnames';
import React, { MouseEvent } from 'react';

interface MarketButtonProps {
  selected: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  title: string;
}

export const MarketButton = ({ selected, onClick, title }: MarketButtonProps) => {
  return (
    <button onClick={onClick} className={classNames(
      'c-header-main-menu-item',
      'market-button',
      'changeWebsites-button',
      { active: selected }
    )}>
      <i className='svg-icon pr-8 icon-sphere'></i>
      {title}
    </button>
  );
};